import * as z from "zod";
import { CardSummary } from "./card";
import { isoDate } from "./common";

export const InventoryImage = z.object({
  id: z.string(),
  src: z.string(),
  altText: z.string().nullable(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  position: z.number(),
});
export type InventoryImage = z.output<typeof InventoryImage>;

export const InventoryVariant = z.object({
  id: z.string(),
  /** The provider's variant id; null for a standalone product. */
  externalId: z.string().nullable(),
  title: z.string(),
  sku: z.string().nullable(),
  price: z.string(),
  compareAtPrice: z.string().nullable(),
  inventoryQuantity: z.number(),
  inventoryPolicy: z.string(),
  barcode: z.string().nullable(),
  position: z.number(),
});
export type InventoryVariant = z.output<typeof InventoryVariant>;

export const INVENTORY_KINDS = ["shopify", "standalone"] as const;

/** A stocked lot: an offer this app created, or a provider product it never did (`offerId` null). */
export const InventoryItem = z.object({
  id: z.string(),
  offerId: z.string().nullable(),
  storeId: z.string(),
  kind: z.enum(INVENTORY_KINDS),
  title: z.string(),
  description: z.string().nullable(),
  vendor: z.string().nullable(),
  productType: z.string().nullable(),
  handle: z.string(),
  status: z.string(),
  tags: z.string().nullable(),
  publishedAt: isoDate.nullable(),
  currencyCode: z.string().nullable(),
  images: z.array(InventoryImage),
  variants: z.array(InventoryVariant),
  externalProductId: z.string().nullable(),
  externalVariantId: z.string().nullable(),
  locationId: z.string().nullable(),
  card: CardSummary.nullable(),
  available: z.number(),
  createdAt: isoDate.nullable(),
  updatedAt: isoDate.nullable(),
});
export type InventoryItem = z.output<typeof InventoryItem>;

export const StockedItem = z.object({
  offerId: z.string(),
  stockId: z.string(),
  kind: z.enum(INVENTORY_KINDS),
  /** Set only when the product was created in Shopify. */
  externalProductId: z.string().nullable(),
});
export type StockedItem = z.output<typeof StockedItem>;

export interface StockCard {
  /** A confirmed card of this store. */
  cardId: string;
  /** Copies in the lot. Default 1. */
  quantity?: number;
  costCents?: number;
  /** Defaults to the card's newest market price. */
  priceCents?: number;
  locationId?: string;
}

export interface LinkOffer {
  offerId: string;
  shopifyProductId: string;
  shopifyVariantId?: string | null;
}
